import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  viewboxHeight: 18,
  viewboxWidth: 12,
};

export default ({
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => (
  <SVGLoader
    viewboxHeight={viewboxHeight}
    viewboxWidth={viewboxWidth}
    {...rest}
  >
    <path d="M9.75 0H2.25C1.65326 0 1.08097 0.237053 0.65901 0.65901C0.237053 1.08097 0 1.65326 0 2.25V15.75C0 16.3467 0.237053 16.919 0.65901 17.341C1.08097 17.7629 1.65326 18 2.25 18H9.75C10.3467 18 10.919 17.7629 11.341 17.341C11.7629 16.919 12 16.3467 12 15.75V2.25C12 1.65326 11.7629 1.08097 11.341 0.65901C10.919 0.237053 10.3467 0 9.75 0V0ZM6 16.8525C5.85166 16.8525 5.70666 16.8085 5.58332 16.7261C5.45999 16.6437 5.36386 16.5266 5.30709 16.3895C5.25032 16.2525 5.23547 16.1017 5.26441 15.9562C5.29335 15.8107 5.36478 15.6771 5.46967 15.5722C5.57456 15.4673 5.7082 15.3958 5.85368 15.3669C5.99917 15.338 6.14997 15.3528 6.28701 15.4096C6.42406 15.4664 6.54119 15.5625 6.6236 15.6858C6.70601 15.8092 6.75 15.9542 6.75 16.1025C6.75 16.3014 6.67098 16.4922 6.53033 16.6328C6.38968 16.7735 6.19891 16.8525 6 16.8525ZM10.5 13.5C10.5 13.6989 10.421 13.8897 10.2803 14.0303C10.1397 14.171 9.94891 14.25 9.75 14.25H2.25C2.05109 14.25 1.86032 14.171 1.71967 14.0303C1.57902 13.8897 1.5 13.6989 1.5 13.5V2.6475C1.5 2.44859 1.57902 2.25782 1.71967 2.11717C1.86032 1.97652 2.05109 1.8975 2.25 1.8975H9.75C9.94891 1.8975 10.1397 1.97652 10.2803 2.11717C10.421 2.25782 10.5 2.44859 10.5 2.6475V13.5Z" />
  </SVGLoader>
);
